import { render, staticRenderFns } from "./HeaderNav.vue?vue&type=template&id=21e03aa7&scoped=true&"
import script from "./HeaderNav.vue?vue&type=script&lang=ts&"
export * from "./HeaderNav.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderNav.vue?vue&type=style&index=0&id=21e03aa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21e03aa7",
  null
  
)

export default component.exports